import type React from "react";
import {observer} from "mobx-react-lite";
import {DrawerMenuItem} from "../drawer/DrawerMenuItem.tsx";
import {List} from "@mui/material";
import Divider from "@mui/material/Divider";
import {DrawerMainLogo} from "../branding/DrawerMainLogo.tsx";
import {useStores} from "../../../stores";

export const MainMenu: React.FC = observer(() => {
    const {p, rootAppStore} = useStores();
    const showSit = p.showCard('sit');
    const showChat = p.showCard('chat');
    return <>
        <List>
            <DrawerMainLogo collapsed={!rootAppStore.isDrawerOpen}/>
            <DrawerMenuItem card="__home__"/>
        </List>
        <Divider/>

        {(showSit || !!p.p.enableDataIngestion || !!p.p.enableTaxonomyIngestion) && <>
            <List>
                {showSit && <DrawerMenuItem card="sit"/>}
                {p.p.enableDataIngestion && <DrawerMenuItem card="data-ingestion"/>}
                {p.p.enableTaxonomyIngestion && <DrawerMenuItem card="taxonomy-ingestion"/>}
            </List>
            <Divider/>
        </>}

        {/*ct={'' + showChat}*/}
        {showChat && <>
            <List>
                <DrawerMenuItem card="chat"/>
            </List>
            <Divider/>
        </>}

        <List>
            <DrawerMenuItem card="taxonomy-suggester"/>
            <DrawerMenuItem card="taxonomy-builder"/>
            <DrawerMenuItem card="categorization-review"/>
            <DrawerMenuItem card="supplier-normalization"/>
            <DrawerMenuItem card="contract-insights"/>
            <DrawerMenuItem card="golden-record"/>
        </List>
        <Divider/>
        <List>
            <DrawerMenuItem card="adv-dashboard"/>
            <DrawerMenuItem card="koi-key-data-facts"/>
            <DrawerMenuItem card="koi-spend-concentration"/>
            <DrawerMenuItem card="koi-ppv"/>
        </List>
    </>;
})
